module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Operations","newOperation":"New Operation","modal":{"newOperationTitle":"New Operation","operationDetailsTitle":"Operation details","cancel":"Cancel"}},"hr":{"title":"Operacije","newOperation":"Nova operacija","modal":{"newOperationTitle":"Nova operacija","operationDetailsTitle":"Detalji operacije","cancel":"Odustani"}}}')
  delete Component.options._Ctor
}
